import { render, staticRenderFns } from "./home-guide.vue?vue&type=template&id=13087d28&scoped=true&"
import script from "./home-guide.vue?vue&type=script&lang=js&"
export * from "./home-guide.vue?vue&type=script&lang=js&"
import style0 from "./home-guide.vue?vue&type=style&index=0&id=13087d28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13087d28",
  null
  
)

export default component.exports